import React from "react";

import { CommentTextIcon } from "assets";

export const ESTIMATES_COMMENTS_VIEW = {
  ICON: <CommentTextIcon />,
  PATH: "comments",
  TITLE: (count: number) => `COMMENTS (${count})`,
};
